import React, { useState, useEffect } from "react";
import ProdAside from "../../components/prodAside";
import ProduitCard from "../../components/poduit-card";
import useMarketStore from "../../store/market";
import { useTranslation } from "react-i18next";
import { scrollToTop } from "../../lib/utils";

const ListProd = () => {
  const { t } = useTranslation()
  const { filteredVille, initialize, searchVille } = useMarketStore(
    (state) => ({
      filteredVille: state.filteredVille,
      initialize: state.initialize,
      searchVille: state.searchVille,
    })
  );

  useEffect(() => {
    scrollToTop()
  }, [])

  const [searchQuery, setSearchQuery] = useState("");

  // Appeler initialize au montage du composant
  useEffect(() => {
    initialize();
  }, [initialize]);

  // Gérer la recherche
  const handleSearch = (e: any) => {
    const query = e.target.value;
    setSearchQuery(query);
    searchVille(query);
  };

  return (
    <div className="h-full flex flex-row justify-start pt-5 pb-1">
      <ProdAside />

      <div className="flex-grow flex flex-wrap gap-y-4 bg-gray-100 max-h-full overflow-scroll p-8">
        {/* Barre de recherche */}
        <div className="w-full flex flex-col items-center mb-6">
          <h1 className="text-3xl my-4">
            {t("prix_produit_marche")}{" "}
          </h1>
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Rechercher les produits ..."
            className="w-full max-w-lg px-4 py-2 border border-gray-300 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-200 mb-6"
          />
        </div>

        {/* Affichage des produits */}
        {filteredVille.length > 0 ? (
          filteredVille.map((item, index) => {
            return <ProduitCard key={index} name={item} />;
          })
        ) : (
          <p className="w-full text-center text-gray-500">
            {t("marche_non_trouve")}
          </p>
        )}
      </div>
    </div>
  );
};

export default ListProd;
